import { Select } from "antd";
import { FunctionComponent } from "react";
import UserStatus from "../../shared/user-status";

interface UserStatusSelectorProps {
  value?: UserStatus;
  onChange?: (value: UserStatus) => void;
  disabled?: boolean;
}

const UserStatusSelector: FunctionComponent<UserStatusSelectorProps> = ({
  value,
  onChange,
  disabled,
}) => {
  return (
    <Select value={value} onChange={onChange} disabled={disabled}>
      <Select.Option key={UserStatus.Invited}>Invited</Select.Option>
      <Select.Option key={UserStatus.Active}>Active</Select.Option>
      <Select.Option key={UserStatus.Inactive}>Inactive</Select.Option>
      <Select.Option key={UserStatus.Pending}>Pending</Select.Option>
    </Select>
  );
};

export default UserStatusSelector;
